angular.module('powerOfAttorney')
    .controller('PowerOfAttorneyEditController', function (toastr, $scope, $rootScope, $uibModalInstance, FocusService, PowerOfAttorney, PowerOfAttorneyConst, data, PowerOfAttorneyService) {
        this.PowerOfAttorneyService = PowerOfAttorneyService
        this.$onInit = () => {
            this.item = data
            if (this.item.id !== null) {
                PowerOfAttorney.get({id: this.item.id}).$promise.then(result => {
                    this.otherRepresentative = !!result.otherRepresentative
                    return this.item = result;
                })
            }
        }

        this.onIndefiniteChanged = () => {
            if (this.item.indefinite) {
                this.item.end = null
            }
        }

        this.onOtherRepresentativeChanged = () => {
            if (this.otherRepresentative) {
                this.item.representative = null
                FocusService.focus("otherRepresentativeInput")
            }
            else {
                this.item.otherRepresentative = null
            }
        }

        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = PowerOfAttorney.update(this.item).$promise
            } else {
                promise = PowerOfAttorney.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(PowerOfAttorneyConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
